import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PedidosCard from './components/PedidosCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const PedidosMain = () => {
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Pedidos'
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <PedidosCard />
        </Col>
      </Row>
    </Container>;
};

export default PedidosMain;
